/* eslint-disable no-console */
import { _Logger } from "./core";
export default _Logger;